<template>
  <more-button-dropdown>
    <template #options-list>
      <ul>
        <li @click="$emit('unlink-item-click')">
          <span>{{ label }}</span>
        </li>
      </ul>
    </template>
  </more-button-dropdown>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LinkedItemDrawerDropdown',

  props: {
    label: {
      type: String,
      default: 'Unlink',
    },
  },

  emits: ['unlink-item-click'],
})
</script>
